/**
 * @file index.tsx
 *
 * @fileoverview Renders the autosuggestions list.
 */
import { Term } from '~/types/types';
import { useIntl } from 'react-intl';
import ClickableChip from '~/jobiqo/components/Job/Form/components/ClickableChip';
import styles from './autosuggestions.module.scss';

export interface AutoSuggestionsProps {
  /**
   * The autosuggested terms.
   */
  suggestions: Term[];
  /**
   * The name of the form field this autosuggestion is bound to.
   */
  fieldName: string;
  /**
   * Callback for when clicking the component.
   */
  onClick?(fieldName: string, chipId: string, chipName: string): void;
}
export function AutoSuggestions({
  suggestions,
  fieldName,
  onClick,
}: AutoSuggestionsProps) {
  const intl = useIntl();

  return (
    <div className={styles.autoSuggestions}>
      <span className={styles.title}>
        {intl.formatMessage({
          id: 'job_autosuggestions_label',
          defaultMessage: 'Suggestions:',
        })}
      </span>
      {suggestions.map((item) => (
        <ClickableChip
          key={item.tid}
          chipId={item.tid.toString()}
          chipName={item.label}
          onClick={onClick}
          fieldName={fieldName}
        >
          {item.label}
        </ClickableChip>
      ))}
    </div>
  );
}

export default AutoSuggestions;
